import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';

const LogoutDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        zIndex: 1500 // Header보다 높은 z-index 설정
      }}
      PaperProps={{
        sx: {
          borderRadius: '20px',
          maxWidth: '400px',
          width: '90%',
        }
      }}
    >
      <DialogTitle sx={{ 
        textAlign: 'center', 
        pt: 4,
        pb: 2
      }}>
        <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
          로그아웃
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ 
          textAlign: 'center',
          pb: 2 
        }}>
          <Typography>
            정말 로그아웃 하시겠습니까?
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ 
        justifyContent: 'center',
        p: 3,
        gap: 1
      }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderRadius: '10px',
            px: 3,
            borderColor: '#ccc',
            color: '#666',
            '&:hover': {
              borderColor: '#999',
              bgcolor: 'rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          취소
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            borderRadius: '10px',
            px: 3,
            bgcolor: '#1976d2',
            '&:hover': {
              bgcolor: '#1565c0'
            }
          }}
        >
          확인
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutDialog; 